import { useQuery } from "react-query";
import { useSelector } from "react-redux";

const useScheduleAList = (
	getScheduleAList,
	getScheduleAPage,
	getScheduleASortBy,
	getScheduleASortDescending,
	userId,
) => {
	const page = useSelector(getScheduleAPage);
	const sortBy = useSelector(getScheduleASortBy);
	const sortDescending = useSelector(getScheduleASortDescending);

	const fetchScheduleAList = () => {
		return getScheduleAList({
			page,
			sortBy,
			sortDescending,
			userId,
		});
	};

	const queryResult = useQuery(
		["scheduleAList", { page, sortBy, sortDescending }],
		fetchScheduleAList,
		{
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useScheduleAList;
